import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import Loader from "./Loader";
import { ToastContainer } from "react-toastify";
//import action file
import { EmpChangePasswords, LoginLoader } from "../../Redux/Action/LoginAction";
//import lottie animation
import Lottie from "react-lottie";
import animationData from "../../images/ze4i9kxVRZ.json";
//import icon
import eyeclose from "../../images/Login/eye close.svg";
import eyeopen from "../../images/Login/view.png";

const EmpChangePassword = () => {
    const dispatch = useDispatch();

    // get prams id from url 
    const { id } = useParams(); 

    const defaultOption = {
        loop: true,
        autoplay: true,
        animationData: animationData,
      };
      const [newpassword, setNewPassword] = useState("");
      const [confirmpassword, setConfirmPassword] = useState("");
      const [newpasswordType, setNewpasswordType] = useState("password");
      const [conpasswordType, setConpasswordType] = useState("password");
      const [passwordError, setPasswordError] = useState("");
      const [error, setError] = useState("")
      const toggleNewPassword = (e) => {
        e?.preventDefault();
        if (newpasswordType === "password") {
          setNewpasswordType("text");
          return;
        }
    
        setNewpasswordType("password");
      };
      const toggleConfirmPassword = (e) => {
        e?.preventDefault();
        if (conpasswordType === "password") {
          setConpasswordType("text");
          return;
        }
        setConpasswordType("password");
      };
    
       useEffect(() =>{
        if(newpassword === confirmpassword){
          setPasswordError("")
        }
       },[newpassword,confirmpassword])
      const handleSubmit = (e) => {
        e.preventDefault();
        const formData = {
          newpassword,
          confirmpassword,
        };
        if (newpassword !== confirmpassword) {
          setPasswordError("The new password and the confirmed password must be the same.");
          return;
        }
        if(id === null ) {
          setError("Invalid Data");
          return;
        }
        dispatch(EmpChangePasswords(formData,id));
        dispatch(LoginLoader());
      };
    
      const newdata = useSelector((state) => state?.Auth?.changepassword);
      useEffect(() => {
        if (newdata.code === 200) {
          setNewPassword("");
          setConfirmPassword("");
        }
      }, [newdata]);
    
      const loader = useSelector((state) => state?.Auth?.loader);
      return (
        <div className="flex justify-between min-h-screen card bg-gold relative">
          {loader && (
            <div>
              <div className="bg-black fixed  top-0 left-0 right-0 w-full h-full z-20 bg-opacity-50">
                <div className="z-[50] absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                  <Loader />
                </div>
              </div>
            </div>
          )}
          {/*--------------------------------------------------------------- Left Side Content-------------------------------------------------------------- */}
          <div className="basis-1/2 flex flex-col justify-center left-container">
            <div>
              <div className="flex flex-col gap-6 justify-center items-center">
                <div>
                  <img src="data:image/png;base64,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"></img>
                </div>
                <div className="font-Roboto text-xl text-[#1A1A1A]">
                  Welcome back!
                </div>
               
                <div className="max-w-[400px]">
                  <Lottie options={defaultOption} />
                </div>
              </div>
            </div>
          </div>
          {/*--------------------------------------------------------------- Right Side Content-------------------------------------------------------------- */}
          <div className="basis-1/2  flex flex-col justify-center items-center right-container">
            <div className="flex flex-col pb-24 w-[377px] login-form">
              <p className="text-2xl font-Roboto mb-10 text-center">
                Change Password
              </p>
              <div>
                <form className="flex flex-col gap-5" onSubmit={handleSubmit}>
                  <div className="flex flex-col gap-2 relative">
                    <label className="font-Roboto text-sm text-[#1A1A1A]">
                      New Password <span className="text-[#fc0000]">*</span>
                    </label>
                    <input
                      placeholder="Enter Password"
                      required
                      type={newpasswordType}
                      className="form-control form-control bg-white p-4 rounded-md shadow-lg focus:outline-none"
                      value={newpassword}
                      onChange={(e) =>{
                        const trimmedValue = e.target.value.trim();
                        setNewPassword(trimmedValue)
                      }}
                      autoComplete="off"
                    />
                    <div className="absolute right-4 top-[42px] z-10 bg-white py-1">
                      <button onClick={toggleNewPassword}>
                        {newpasswordType === "password" ? (
                          <img src={eyeopen} alt="new"></img>
                        ) : (
                          <img src={eyeclose} alt="new"></img>
                        )}
                      </button>
                    </div>
                    <div className="relative mt-4">
                      <div>
                        <label className="font-Roboto text-sm text-[#1A1A1A]">
                          Confirm Password <span className="text-[#fc0000]">*</span>
                        </label>
                      </div>
                      <input
                        placeholder="Enter Password"
                        required
                        type={conpasswordType}
                        className="form-control form-control bg-white p-4 rounded-md shadow-lg focus:outline-none w-full mt-2"
                        value={confirmpassword}
                        onChange={(e) =>{
                            const trimmedValue = e.target.value.trim()
                            setConfirmPassword(trimmedValue)
                        }}
                        autoComplete="off"
                      />
                      <div className="absolute right-4 top-[46px] z-10 bg-white py-1">
                        <button onClick={toggleConfirmPassword}>
                          {conpasswordType === "password" ? (
                            <img src={eyeopen} alt="new"></img>
                          ) : (
                            <img src={eyeclose} alt="new"></img>
                          )}
                        </button>
                      </div>
                      {passwordError && (
                        <p className="text-red-500 text-sm mt-5">{passwordError}</p>
                      )}
                      {error && (
                        <p className="text-red-500 text-sm mt-5">{error}</p>
                      )}
                    </div>
                  </div>
    
                  <button
                    className="flex justify-center bg-[#FCDD00] hover:shadow-xl hover:transition-all duration-700 rounded-lg p-4 text-sm font-Roboto text-[#1A1A1A]"
                    type="submit"
                  >
                    Update Password
                  </button>
                </form>
              </div>
              <ToastContainer />
            </div>
          </div>
        </div>
      );
}

export default EmpChangePassword;
